import axios from 'axios';
import { Toast } from '../layout/Alerta';

const BASE_URL = process.env.REACT_APP_APPLICATION_ENDPOINT || 'http://localhost:3000';

export const crudService = async (catalogo: string, operacion: string, id: null | string = null, data: null | any = null) => {
    try {
        const token = localStorage.getItem('jwtToken');
        const headers = {
            'Authorization': `${token}`,
            'Content-Type': 'application/json',
        };

        let response;

        const rutas = {
            crear: `${BASE_URL}/${catalogo}`,
            obtener: `${BASE_URL}/${catalogo}`,
            obtenerPorId: `${BASE_URL}/${catalogo}/${id}/detalle`,
            actualizar: `${BASE_URL}/${catalogo}/${id}/actualiza`,
            recupera: `${BASE_URL}/${catalogo}/${id}/recupera`,
            baja: `${BASE_URL}/${catalogo}/${id}/baja`,
        };

        switch (operacion) {
            case 'obtener':
                response = await axios.get(rutas.obtener, { headers });
                break;

            case 'obtenerPorId':
                response = await axios.get(rutas.obtenerPorId, { headers });
                break;

            case 'crear':
                response = await axios.post(rutas.crear, data, { headers });
                break;

            case 'actualizar':
                response = await axios.put(rutas.actualizar, data, { headers });
                break;

            case 'baja':
                response = await axios.put(rutas.baja, {}, { headers });
                break;

            case 'recupera':
                response = await axios.put(rutas.recupera, {}, { headers });
                break;

            default:
                Toast.fire({
                    icon: "error",
                    title: "Operación no válida",
                });
                return null;
        }

        return response.data;
    } catch (error: any) {
        console.error(`Error al realizar operación ${operacion} en ${catalogo}: ${id}`, error);

        const errorMessage = error?.response?.data?.message || "Ocurrió un error inesperado.";
        const errorCode = error?.response?.status || "Desconocido";

        Toast.fire({
            icon: "error",
            title: `Error (${errorCode}): ${errorMessage}`,
        });

        return null;
    }
};
